// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"2c298436","418":"2e803ce8","480":"e72c5e0e"}[chunkId] + ".js";
};